<div class="c-resource-edit container">
  <div class="row">
    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-center mt-3 mb-3">
        <h1 class="mb-auto">{{ resource.title }}</h1>
        <button
          *ngIf="hasPartOfResource"
          class="btn btn-default mt-auto mb-auto"
          (click)="removeHasPartResource()"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
          <span
            class="sr-only"
            i18n="@@resourceEdit-button-removeHasPartResource"
            >Remove has part</span
          >
        </button>
      </div>
      <rl-resource-edit-form
        [resource]="resource"
        [visibleFields]="visibleFields.mainResource"
        [formPart]="fieldContentMenuFormPart.PRIMARY"
        (fieldOptionClicked)="onFieldOptionClicked($event)"
        (formValueUpdated)="onFormValueUpdated()"
        #mainResourceForm
      ></rl-resource-edit-form>

      <ng-container *ngIf="resource.part_of">
        <div
          class="d-flex justify-content-between align-items-center mt-3 mb-3"
        >
          <h2
            class="mb-auto"
            i18n="@@resourceEdit-heading-isPartOf"
            class="mb-auto"
          >
            Is part of
          </h2>
          <button
            class="btn btn-default mt-auto mb-auto"
            (click)="removePartOfResource()"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
            <span
              class="sr-only"
              i18n="@@resourceEdit-button-removePartOfResource"
              >Remove part of</span
            >
          </button>
        </div>
        <rl-resource-edit-form
          [resource]="resource.part_of"
          [visibleFields]="visibleFields.partOfResource"
          [formPart]="fieldContentMenuFormPart.PART_OF"
          (fieldOptionClicked)="onFieldOptionClicked($event)"
          (formValueUpdated)="onFormValueUpdated()"
          #partOfResourceForm
        ></rl-resource-edit-form>
      </ng-container>

      <div>
        <button
          class="btn btn-default me-2"
          (click)="back()"
          i18n="@@resourceEdit-btn-back"
        >
          Back
        </button>
        <button
          class="btn btn-primary"
          (click)="previewChanges()"
          i18n="@@resourceEdit-btn-previewChanges"
        >
          Preview changes
        </button>
      </div>
    </div>

    <div class="col-md-6">
      <h2 class="h3" i18n="@@resourceEdit-heading-addFields">
        Improve metadata by adding fields to the form
      </h2>
      <rl-resource-edit-add-fields
        [hasPartOfResource]="hasPartOfResource"
        [visibleFields]="visibleFields"
        (addedField)="addFieldToForm($event)"
      ></rl-resource-edit-add-fields>

      <div class="row row-cols-2 row-cols-xl-3 g-3 list-unstyled m-0 p-0 w-100">
        <div class="col">
          <button
            (click)="addPartOfResource()"
            class="btn btn-default text-start w-100 position-relative text-dark resource-edit__button"
            [attr.aria-disabled]="hasPartOfResource ? 'true' : null"
            [class.bg-light]="hasPartOfResource"
            i18n="@@resourceEdit-button-addPartOfResource"
          >
            Add part of
          </button>
        </div>

        <div class="col">
          <button
            (click)="addHasPartResource()"
            [attr.aria-disabled]="hasPartOfResource ? 'true' : null"
            [class.bg-light]="hasPartOfResource"
            class="btn btn-default text-start w-100 position-relative text-dark resource-edit__button"
            i18n="@@resourceEdit-button-addHasPartResource"
          >
            Add has part
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
